import React, { useState } from "react";
import cn from "classnames";
import OutsideClickHandler from "react-outside-click-handler";
import styles from "./Dropdown.module.sass";
import Tooltip from "../Tooltip";

const Dropdown = ({
    className,
    classDropdownHead,
    classDropdownLabel,
    value,
    setValue,
    options,
    label,
    tooltip,
    small,
    upBody,
    required,
    displayFormatter, // Fonction pour formater l'affichage de la sélection
    placeholder = "Sélectionner", // Texte par défaut quand aucune valeur n'est sélectionnée
}) => {
    const [visible, setVisible] = useState(false);

    const handleClick = (value) => {
        setValue(value);
        setVisible(false);
    };

    return (
        <OutsideClickHandler onOutsideClick={() => setVisible(false)}>
            {label && (
                <div className={cn(styles.label, classDropdownLabel)}>
                    {label}{required && <span className={styles.required}>*</span>}{" "}
                    {tooltip && (
                        <Tooltip
                            className={styles.tooltip}
                            title={tooltip}
                            icon="info"
                            place="right"
                        />
                    )}
                </div>
            )}
            <div
                className={cn(
                    styles.dropdown,
                    className,
                    { [styles.small]: small },
                    {
                        [styles.active]: visible,
                    }
                )}
            >
                <div
                    className={cn(styles.head, classDropdownHead)}
                    onClick={() => setVisible(!visible)}
                >
                    <div className={styles.selection}>
                        {displayFormatter && value ? 
                            displayFormatter(value) :
                            (typeof value === 'object' && value !== null ? 
                                (value.label || value.title || value.value || placeholder) : 
                                (value || placeholder))}
                    </div>
                </div>
                <div className={cn(styles.body, { [styles.bodyUp]: upBody })}>
                    {options.map((x, index) => {
                        // Déterminer si cette option est sélectionnée
                        const isSelected = typeof value === 'object' && value !== null
                            ? (x.value === value.value)
                            : (x === value);
                        
                        // Déterminer le texte à afficher
                        const displayText = typeof x === 'object' && x !== null
                            ? (x.label || x.title || x.value)
                            : x;
                            
                        return (
                            <div
                                className={cn(styles.option, {
                                    [styles.selectioned]: isSelected,
                                })}
                                onClick={() => handleClick(x, index)}
                                key={index}
                            >
                                {displayText}
                            </div>
                        );
                    })}
                </div>
            </div>
        </OutsideClickHandler>
    );
};

export default Dropdown;
